<template>


  <div class="card mt-3 mb-3 mb-0 border">
    <div class="card-body">
      <div class="row">
        <div class="col-3 pr-0">
          <nav aria-label="...">
            <ul class="pagination text-smallest mb-0 pb-0">
              <li class="page-item" :class="{ 'disabled': pagination.currentPage === 1}">
                <button class="page-link" @click="setPage(1)">First</button>
              </li>

              <li v-for="page in paginationPages" :key="page" class="page-item"
                  :class="{ 'disabled': page === '...', 'active': page === pagination.currentPage }">
                <button class="page-link" @click="setPage(page)">{{ page }}</button>
              </li>

              <li class="page-item" :class="{ 'disabled': pagination.currentPage === pagination.lastPage}">
                <button class="page-link" @click="setPage(pagination.lastPage)">Last</button>
              </li>
            </ul>
          </nav>
        </div>
        <div class="col-3 pr-0">
          <div class="row">
            <div class="col-5 pr-0 text-right">
              <label class="col-form-label font-weight-bold">Filter By: </label>
            </div>
            <div class="col-6 pr-1">
              <select class="form-control form-control-sm text-uppercase" id="fleetList" v-model="filters.fleet_id">
                <option :value="null">ALL FLEET</option>
                <template v-for="fleet in fleetKeys">
                  <option :value="fleet.id" v-if="fleet?.name !== 'N/A' && fleet.code !== 'N/A'">
                    {{fleet.name ? fleet.name.toUpperCase() : ''}}
                  </option>
                </template>
              </select>
            </div>
          </div>
        </div>
        <div class="col-4 pr-1 pl-1" v-if="['k-line-persons', 'k-line-persons2'].includes(user.roles_permissions?.roles[0]) === false">
          <div class="row">
            <div class="col-6 pr-1">
              <select class="form-control form-control-sm text-uppercase" id="CountryList" v-model="filters.country_id">
                <option :value="null">ALL COUNTRIES</option>
                <option v-for="country in countryKeys" :key="country.id" :value="country.id">
                  {{ country?.name }}
                </option>
              </select>
            </div>
            <div class="col-6">
              <select class="form-control form-control-sm text-uppercase" id="PortList" v-model="filters.port_id" :disabled="!ports.length">
                <option :value="null">ALL PORTS</option>
                <option v-for="port in ports" :key="port.id" :value="port.id">
                  {{ port?.name }} {{ port.locode_wrap }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="col-6" v-else>
          <div class="row">
            <div class="col-6 pr-0">
              <select class="form-control form-control-sm text-uppercase" id="CountryList" v-model="filters.country_id">
                <option :value="null">ALL COUNTRIES</option>
                <option v-for="country in countryKeys" :key="country.id" :value="country.id">
                  {{ country?.name }}
                </option>
              </select>
            </div>
            <div class="col-6">
              <select class="form-control form-control-sm text-uppercase" id="PortList" v-model="filters.port_id" :disabled="!ports.length">
                <option :value="null">ALL PORTS</option>
                <option v-for="port in ports" :key="port.id" :value="port.id">
                  {{ port?.name }} {{ port.locode_wrap }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="col-2 pr-4 pl-1" v-if="['k-line-persons', 'k-line-persons2'].includes(user.roles_permissions?.roles[0]) === false">
          <button v-if="finalizedReports.length" class="ml-2 mr-2 e-btn force-white-all w-100" @click="downloadReport('excel')" type="button" :disabled="loading" :class="loading ? 'e-btn-blue-gray cursor-not-allowed' : 'e-btn-primary'">
            <font-awesome-icon class="mr-1" icon="download"/>
            Download
          </button>
          <button v-else class="ml-2 mr-2 e-btn e-btn-blue-gray force-white-all w-100" type="button" disabled style="cursor: not-allowed">
            <font-awesome-icon class="mr-1" icon="download"/>
            Download
          </button>
        </div>
      </div>
      <hr style="border-bottom: 2px solid black">
      <div class="text-center">
        <div class="row no-gutters" style="overflow-y: auto">
          <div class="col-12">
            <table class="small e-tbl dark-border">
              <thead class="bg-white" style="position: sticky; top: 0; z-index: 2">
              <tr>
                <th class="align-middle" style="width: 1em" scope="col">#</th>
                <th class="align-middle" scope="col">VESSEL</th>
                <th class="align-middle" style="width: 6em" scope="col">FLAG</th>
                <th class="align-middle" scope="col">MANAGER</th>
                <th class="align-middle" style="min-width: 25em" scope="col">REPORT TITLE</th>
                <th class="align-middle" style="width: 5em" scope="col">STATUS</th>
                <th class="align-middle" style="width: 10em" scope="col">PORT</th>
                <th class="align-middle" style="width: 7em" scope="col">COUNTRY</th>
                <th class="align-middle" style="min-width: 9em" scope="col">INSPECTION DATE</th>
                <th class="align-middle" style="width: 1em; font-size: 11px;" scope="col">PSC REPORT</th>
                <th class="align-middle" style="min-width: 9em" scope="col">NO. DEF</th>
                <th class="align-middle" style="min-width: 9em" scope="col">DEF STATUS</th>
                <th class="align-middle" style="min-width: 9em" scope="col">DETENTION</th>
                <th class="align-middle" style="width: 12em" scope="col">RESPONSIBLE</th>
                <th class="align-middle" style="width: 12em" scope="col">PERSON IN CHARGE</th>
                <th class="align-middle" style="width: 12em" scope="col">CREATED BY</th>
                <th class="align-middle" style="width: 70px" scope="col">ACTION</th>
              </tr>
              </thead>
              <tbody>
              <tr v-if="loading">
                <td colspan="100%">
                  <loading></loading>
                </td>
              </tr>
              <tr v-else-if="!finalizedReports.length && !loading">
                <td colspan="100%" class="text-center py-3">
                  No records found.
                </td>
              </tr>
              <template v-else>
                <template v-for="(report, index) in finalizedReports">
                  <tr class="text-uppercase" :key="report.id" :class="[new Date(report.inspection_date) <= new Date('2000-01-01') ? 'test-data-row' : '' ]">
                    <td>{{ index + pagination.from }}</td>
                    <td>{{ report.vessel }}</td>
                    <td>{{ report?.flag_name }}</td>
                    <td>{{ report.manager }}</td>
                    <td>{{ report.title }}</td>
                    <td class="align-middle text-white" :class="['bg-'+report.report_status_color]">
                      {{ report.report_status }}
                    </td>
                    <td>{{ report.port }}</td>
                    <td>{{ report.country }}</td>
                    <td>{{ report.inspection_date }}</td>
                    <td>
                      <template v-if="report.pscAttachment">
                        <font-awesome-icon icon="file-pdf" v-if="report.pscAttachment.has_file" @click="viewDownloadFile(report.pscAttachment,1,'view',report.id)" size="3x"
                                           class="force-danger-all" style="cursor: pointer">
                        </font-awesome-icon>
                        <font-awesome-icon icon="file-pdf" v-else  size="3x"></font-awesome-icon>
                      </template>
                    </td>
                    <td class="align-middle text-center"><p class="py-0 my-0" :class="{'h5 text-danger':report.deficiencyCount > 0}">{{ report.deficiencyCount }}</p></td>
                    <td class="p-2" style="width: 6rem">
                      <DeficiencyStatusIndicator :data="report.deficiencyCounts"></DeficiencyStatusIndicator>
                    </td>
                    <td><p class="py-0 my-0" :class="{'h5 text-danger':report.detention}">{{ report.detention ? 'YES' : 'NO' }}</p></td>
                    <td>{{ report.responsible_person }}</td>
                    <td>{{ report.person_in_charge }}</td>
                    <td>{{ report.created_by?.name }}</td>
                    <td class="align-middle text-center">
                      <div class="dropdown dropright my-1">
                        <button id="actionDropdown" aria-expanded="false" aria-haspopup="true"
                                class="btn btn-sm btn-secondary force-white-all" data-toggle="dropdown">
                          <font-awesome-icon icon="cogs"/>
                        </button>
                        <div aria-labelledby="actionDropdown" class="dropdown-menu py-0">
                          <button class="dropdown-item text-secondary font-weight-bolder"
                                  @click="showPscInspection(report.id)"
                                  v-if="isAllowed('psc.index.view') || isAllowed('psc.main.view')">
                            <font-awesome-icon icon="eye"/>
                            View
                          </button>
                          <button class="dropdown-item text-secondary font-weight-bolder"
                                  @click="showPscInspectionNewTab(report.id)"
                                  v-if="isAllowed('psc.index.view') || isAllowed('psc.main.view')">
                            <font-awesome-icon icon="share"/>
                            View on New Tab
                          </button>
                          <template v-if="user.is_vessel === true">
                            <button class="dropdown-item text-secondary font-weight-bolder text-danger"
                                    @click="verifyDelete(report)"
                                    v-if="user.vessel_id === report.vessel_id">
                              <font-awesome-icon icon="trash" class="force-danger-all"/>
                              Delete
                            </button>
                          </template>
                          <template v-else>
                            <button class="dropdown-item text-secondary font-weight-bolder text-danger"
                                    @click="verifyDelete(report)"
                                    v-if="isAllowed('psc.index.delete') || user.id === report.created_by_id">
                              <font-awesome-icon icon="trash" class="force-danger-all"/>
                              Delete
                            </button>
                          </template>
                        </div>
                      </div>
                    </td>
                  </tr>
                </template>
              </template>
              </tbody>
            </table>
          </div>
        </div>
        <new-psc-inspection-report/>
        <import-psc-report-modal />
      </div>
    </div>
  </div>

  <!--  TODO: create NewPscInspection modal  -->
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {vueAppMixin} from "@/mixins/vueAppMixin";
import {PaginationMixin} from "@/mixins/PaginationMixin";
import AppLoading from "@/components/elements/AppLoading";
import NewPscInspectionReport from "@/components/layouts/NewPscInspectionReport";
import {AlertService} from "../../../services/AlertService";
import {permissionMixin} from "@/mixins/permissionMixins";
import {ReportService} from "@/services/ReportService";
import _ from 'lodash';
import ImportPscReportModal from "@/components/layouts/ImportPscReportModal.vue";
import attachmentMixin from "@/mixins/attachmentMixin";
import DeficiencyStatusIndicator from "@/components/modules/psc/DeficiencyStatusIndicator.vue";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import {PSC_REPORT_INDEX} from "@/services/ConstantService";
import {UrlService} from "@/services/UrlService";
import axios from "axios";
import {GlobalService} from "@/services/GlobalService";
import en from "vue2-datepicker/locale/es/en";

export default {
  name: "PscIndex",
  data() {
    return {
      filters: {
        page: 1,
        count: 30,
        fleet_id: null,
        status_id: null,
        office_id: null,
        port_id: null,
        country_id: null,
        flag_id: null,
        company_id: null,
        search:'',
        date_from : null,
        date_to   : null,
        detention_status : true,
      },
      date_range : null,
      ports:[],
      exportVesselId: null,
      exportDeficiencyCount: null,
      toExport: false,
      loading: false,
    }
  },
  components: {
    DeficiencyStatusIndicator,
    'new-psc-inspection-report': NewPscInspectionReport,
    'import-psc-report-modal': ImportPscReportModal,
    'loading': AppLoading,
    DatePicker
  },
  // mixins: [PaginationMixin],
  mixins: [vueAppMixin, PaginationMixin, permissionMixin,attachmentMixin],
  methods: {
    ...mapActions([
      'addRequestKeys',
      'generateRequestKeys',
      'getPscReports',
      'deletePsc',
      'downloadPscList',
      'downloadPscStatusHistory',
    ]),
    getDownloadParam(fileType) {
      const selectedCountry = this.countryKeys.filter((country) => {
        return country.id === this.filters.country_id;
      });

      const selectedPort = this.ports.filter((port) => {
        return port.id === this.filters.port_id;
      });

      const selectedFleet = this.fleetKeys.filter(fleet => {
        return fleet.id === this.filters.fleet_id
      })

      const params = {
        file_type  : fileType,
        detention_status  : true,
        country    : selectedCountry.length === 0 ? 'ALL COUNTRIES' : selectedCountry[0].name,
        port       : selectedPort.length === 0 ? 'ALL PORTS'        : selectedPort[0].name,
        fleet      : selectedFleet.length === 0 ? 'ALL FLEET'       : selectedFleet[0].name,
      }

      if (this.filters.country_id !== null) {
        params.country_id = this.filters.country_id;
      }

      if (this.filters.port_id !== null) {
        params.port_id = this.filters.port_id;
      }

      if (this.filters.fleet_id !== null) {
        params.fleet_id = this.filters.fleet_id;
      }

      if (this.filters.date_from !== null) {
        params.date_from = this.filters.date_from;
      }

      if (this.filters.date_to !== null) {
        params.date_to = this.filters.date_to;
      }

      return params;
    },
    async downloadReportStatusHistory() {
      const params = this.getDownloadParam('excel');
      swal.fire({
        'title': `GENERATING PSC REPORTS STATUS HISTORY <br>Please wait.....`,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false
      })
      swal.showLoading()
      let response = await this.downloadPscStatusHistory(params);
      swal.close();

      if (response === false) {
        return AlertService.errorAlert('Theres an error downloading the file. Please try again later!', 'DOWNLOADING FILE');
      }
      let mime_type = 'application/vnd.ms-excel';
      let url = window.URL.createObjectURL(new Blob([response],{type:mime_type}))

      let filename=`PSC_STATUS_HISTORY_REPORT_` +
        params.country.replace(/\s/g, '_').toUpperCase() +
        `_` + params.port.replace(/\s/g, '_').toUpperCase() +
        `_` + params.fleet.replace(/\s/g, '_').toUpperCase() +
        `.xlsx`;

      const link = document.createElement('a');
      link.setAttribute('href', url);
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
    },
    async downloadReport(fileType){
      const params = this.getDownloadParam(fileType);
      swal.fire({
        'title': `GENERATING PSC INSPECTION LIST ${fileType === 'pdf' ? 'PDF' : 'EXCEL'} REPORT <br>Please wait.....`,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false
      })
      swal.showLoading()
      let response = await this.downloadPscList(params);
      swal.close();
      if (response === false) {
        return AlertService.errorAlert('Theres an error downloading the ' + fileType.toUpperCase() + ' file. Please try again later!', 'DOWNLOADING FILE');
      }
      let mime_type = fileType === 'pdf' ? 'application/pdf' : 'application/vnd.ms-excel'
      let url = window.URL.createObjectURL(new Blob([response],{type:mime_type}))

      fileType = (fileType !== 'pdf') ? 'xlsx' : 'pdf';

      const date = new Date().toISOString().split("T")[0];
      let filename=`PSC_Detention_${date}` +
        `.${fileType}`;

      const link = document.createElement('a');
      link.setAttribute('href', url);
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
    },
    getPortsByCountry(id) {
      this.ports = id ? this.portKeys.filter(port => port.country_id === id) : [];
      this.filters.port_id=null;
    },
    async exportBlankTemplate(resetToDefault = false) {
      if (resetToDefault === true) {
        this.toExport = false;
        this.exportVesselId = null;
        this.exportDeficiencyCount = null;
        return;
      }

      let vesselId = this.exportVesselId;
      let deficiencyCount = this.exportDeficiencyCount;
      const deficiencyCountIsNaN = isNaN(deficiencyCount);
      const vessel = this.vesselKeys.filter(vessel => vessel.id === vesselId)[0];

      let errorMsg = "";

      if (!vessel && !deficiencyCount) {
        errorMsg = "Number of Deficiency and Vessel is required";
      } else if (!vessel) {
        errorMsg = "Please select a vessel";
      } else if (deficiencyCountIsNaN || deficiencyCount < 1 || deficiencyCount > 30 || !deficiencyCount) {
        if (deficiencyCountIsNaN) {
          errorMsg = "Number of Deficiency must be a number";
        } else if (deficiencyCount > 30) {
          errorMsg = "Number of Deficiency must be a positive number with range from 1 to 30";
        }
      }

      if (errorMsg != "") {
        AlertService.errorAlert(errorMsg, 'PSC Inspection Export');
        // await this.exportBlankTemplate(true);
        return;
      }

      swal.fire({title: 'Downloading Template... Please wait...'});
      swal.showLoading();

      deficiencyCount = parseInt(isNaN(deficiencyCount) || !deficiencyCount ? 0 : deficiencyCount);
      const vesselName = (vessel.name).toUpperCase();
      const report = 'Psc Inspection';
      const name = [report, 'Report', vesselName, 'TEMPLATE'].join(' ');

      let path = name.replaceAll(' ', '_') + '.xlsx';
      let mime_type = 'application/vnd.ms-excel';
      const response = await ReportService.downloadPscReportTemplate(vessel.id, this.exportDeficiencyCount);

      let url = window.URL.createObjectURL(new Blob([response.data], {type: mime_type}));
      const link = document.createElement('a');
      link.setAttribute('href', url);
      link.setAttribute('download', path);

      swal.close();
      document.body.appendChild(link);
      link.click();

      AlertService.successAlert('Vessel "' + vesselName + '" ' + report + ' Template has downloaded successfully', report);
      await this.exportBlankTemplate(true);
    },
    async setPage(page = null) {
      this.loading = true;
      this.pagination.currentPage = page ?? 1;
      this.filters.page = page ?? 1
      await this.getPscReports(this.filters)
      this.loading = false;
    },
    showPscInspection(inspectionId) {
      this.$router.push(
        {
          name: 'PscMain',
          params: {
            id: inspectionId
          }
        }
      )
    },
    async showPscInspectionNewTab (inspectionId) {
      const route= this.$router.resolve(
        {
          name: 'PscMain',
          params: {
            id: inspectionId,
          },
        },
      )
      window.open(route.href,'_blank')
    },
    async verifyDelete(psc) {
      if (await AlertService.confirmDeleteAlert('DELETION OF PSC REPORT', 'Do you want to Delete this PSC Record?', 'Yes, Proceed!')) {
        swal.fire({
          title:'ENTER YOUR PASSWORD',
          input: 'password',
          inputAttributes: {
            autocapitalize: 'off'
          },
          confirmButtonText:'PROCEED DELETION',
          cancelButtonText: 'CANCEL',
          showCancelButton:true,
          allowOutsideClick:false,
          allowEscapeKey:false,
          allowEnterKey:false,
          confirmButtonColor:'#dc3545',
          showLoaderOnConfirm:true,
          preConfirm:async (inputValue)=> {
            const params = {type: 1, id: psc.id,password: inputValue}
            let response = await this.deletePsc(params);
            if (typeof response === 'boolean' && response) {
              return response;
            } else {
              if (response.hasOwnProperty('message') && !response.hasOwnProperty('errors')) {
                swal.showValidationMessage(response.message);
              }
              else{
                swal.showValidationMessage(response.errors.password.join(','));
              }
            }
          }
        })
          .then(async (result)=>{
            if(result.isConfirmed){
              this.successAlert('PSC RECORD DELETED SUCCESSFULLY','DELETE PSC REPORT');
              this.setPage(1)
            }
          });
      }
    },
    initializeWatcher(){
      this.$watch(()=>this.$route.query,async (present,previous)=>{
        this.filters.page=1
        this.filters.search=present?.search
        await this.getPscReports(this.filters)
      });
    },
  },
  async created() {
    this.loading = true;
    this.initializeWatcher()

    this.addRequestKeys([
      'getVesselKeys',
      'getFleetListKeys',
      'getReportStatusKeys',
      'getMngmtOfficeKeys',
      'getCountryListKeys',
      'getMngmtCompanyKeys',
      'getTimezoneKeys',
      'getEventOneKeys',
      'getEventImpactKeys',
      'getPortKeys',
    ]);

    // @NOTE: SAMPLE @params object
    // const params = {
    //   test_param: 'this is a test',
    //   __params: {
    //     getReportStatusKeys: {
    //       id: 4,
    //     }
    //   },
    // };

    const params = {};
    await this.generateRequestKeys(params);
    await this.getPscReports(this.filters);
    this.setPage2=_.debounce(this.setPage,250);

    this.loading = false;
  },
  computed: {
    en() {
      return en
    },
    ...mapGetters([
      'isLoading', 'reports', 'vesselKeys', 'fleetKeys', 'portKeys',
      'mngmntOfficeKeys', 'countryKeys', 'reportStatusKeys', 'mngmtCompanyKeys'
    ]),
    finalizedReports() {
      let newReports = [];
      this.reports.forEach((report) => {
        let satisfiedCondition = (report.report_status_id !== 1) || (report.report_status_id === 1 && this.user.id === report.created_by_id)
        if (satisfiedCondition === true || this.isElite() === true) {
          newReports.push(report);
        }
      })

      return newReports;
    }
  },
  watch:{
    async 'filters.count'(){
      this.loading = true;
      await this.getPscReports(this.filters)
      this.loading = false;
    },
    async 'filters.fleet_id'(){
      this.loading = true;
      await this.getPscReports(this.filters)
      this.loading = false;
    },
    async 'filters.country_id'(id) {
      this.$nextTick(() => {
        this.getPortsByCountry(id);
      })
      this.loading = true;
      await this.getPscReports(this.filters)
      this.loading = false;
    },
    async 'filters.port_id'() {
      this.loading = true;
      await this.getPscReports(this.filters)
      this.loading = false;
    },
    async 'date_range'() {
      this.loading = true;
      this.filters.date_from = this.date_range[0]
      this.filters.date_to = this.date_range[1]
      await this.getPscReports(this.filters)
      this.loading = false;
    }
  }
}
</script>

<style scoped>
table tr td {
  font-size: 10px;
}
.dark-border{
  border: 3px solid #b3b3b3;
}

.force-align-top {
  display: inline-block;
  vertical-align: top;
}
/*#exportDeficiencyCount {
  max-width: 30%;
}*/

</style>
